// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'eu-west-1:26b572f3-fe3f-4824-a20e-1b5ec64e232f',
    'aws_cognito_region': 'eu-west-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'silje-hosting-mobilehub-940232879',
    'aws_content_delivery_bucket_region': 'eu-west-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd1viu6kvd51kr2.cloudfront.net',
    'aws_mobile_analytics_app_id': 'ab19053e29924ab5837eea5bb83d75b3',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '2512c903-7608-4fec-9ba5-6390dbac56c6',
    'aws_project_name': 'Silje',
    'aws_project_region': 'eu-west-1',
    'aws_resource_name_prefix': 'silje-mobilehub-940232879',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'eu-west-1_AW8wCegPs',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '4lsm7jl9uhlnt1vlvgu92oruc',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js